import React, { Component } from 'react';
import styled from 'styled-components';

import Color from '../../utils/colors';

function getInnerHeight() {
    return window.innerHeight;
}

export default class PopUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clientHeight: getInnerHeight(),
        };

        this.handleResize = this.handleResize.bind(this);
        this.handleEscClose = this.handleEscClose.bind(this);

        window.addEventListener('resize', this.handleResize);
        window.addEventListener('keydown', this.handleEscClose);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('keydown', this.handleEscClose);
    }

    handleEscClose(event) {
        if (event.keyCode === 27) {
            const { handleClosePopUp } = this.props;
            handleClosePopUp();
        }
    }

    handleResize() {
        this.setState({ clientHeight: getInnerHeight() });
    }

    render() {
        const { clientHeight } = this.state;
        const {
            className,
            popUpComponent: PopUpComponent,
            componentProps,
            handleClosePopUp,
            scrollToForm,
            handleOpenPopUp,
        } = this.props;

        return (
            <>
                <Container className={className} height={clientHeight}>
                    {PopUpComponent && (
                        <PopUpComponent
                            // eslint-disable-next-line react/jsx-props-no-spreading
                            {...componentProps}
                            handleClosePopUp={handleClosePopUp}
                            scrollToForm={scrollToForm}
                            handleOpenPopUp={handleOpenPopUp}
                        />
                    )}
                </Container>
            </>
        );
    }
}

const Container = styled.div`
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    width: 100%;
    height: ${({ height }) => `${height}px`};
    min-width: 320px;

    display: flex;
    justify-content: center;

    /* background-color: ${Color.TEXT_SECONDARY}; */
    background: rgba(51, 51, 51, 0.56);
`;
